import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formValues } from 'redux-form';

import { MIN, MAX } from 'helpers/fieldOptions';

import cn from './styles.local.less';

class SelectRangeItem extends PureComponent {
  static propTypes = {
    maxName: PropTypes.string,
    maxValue: PropTypes.any,
    minName: PropTypes.string,
    minValue: PropTypes.any,
    onChanged: PropTypes.func.isRequired,
    renderField: PropTypes.func,
  };

  render() {
    const { onChanged, minName, maxName, minValue, maxValue, renderField } =
      this.props;

    return (
      <div className={cn.root}>
        <div className={cn.selectCol}>
          <div className={cn.label}>{__('search.filters.selectRangeFrom')}</div>
          {renderField({
            compareValue: maxValue,
            modalTitle: __('search.filters.selectRangeFrom'),
            name: minName,
            onChanged,
            rangeType: MIN,
            isMin: true,
            value: minValue,
          })}
        </div>
        <div className={cn.dashCol}> - </div>
        <div className={cn.selectCol}>
          <div className={cn.label}>{__('search.filters.selectRangeTo')}</div>
          {renderField({
            compareValue: minValue,
            value: maxValue,
            modalTitle: __('search.filters.selectRangeTo'),
            name: maxName,
            onChanged,
            rangeType: MAX,
            isMax: true,
          })}
        </div>
      </div>
    );
  }
}

export default formValues(({ minName, maxName }) => ({
  minValue: minName,
  maxValue: maxName,
}))(SelectRangeItem);
